import Constants from "./Constants";

const formattedNetworks = (netList = [], noNetworkText = '') => {
    
    const mpi = { name: 'MultiPlan Network', value: [] };
    const phcs = { name: 'PHCS Network', value: [] };
    const other = { name: 'Other Network', value: [] };

    if (Array.isArray(netList) && netList.length > 0) {
        netList.forEach((net) => {
            if (!shouldHideNetwork(net.networkCode)) {
                processNetwork(net, mpi, phcs, other, noNetworkText);
            }
        });
    }

    repositionOtherNetwork(other);
    
    return { mpi, phcs, other };
};

const shouldHideNetwork = (networkCode) => {
    return Constants.HIDE_NETWORK_CODES.includes(networkCode);
};

const processNetwork = (net, mpi, phcs, other, noNetworkText) => {
    switch (net.networkCode) {
        case "PHCS":
            formatNetworkStatement(net, true);
            phcs.value.push(net);
            break;
        case "MPI":
            formatNetworkStatement(net, false);
            mpi.value.push(net);
            break;
        default:
            handleOtherNetwork(net, other, noNetworkText);
            break;
    }
};

const formatNetworkStatement = (net, isPHCS) => {
    if (isPHCS) {
        net.networkStatementName = net.networkStatementName.replace("(", "<i>(").replace(")", ")</i>");
    } else if (net.networkStatementName === "I don't see any of these statements on my ID Card") {
        net.networkStatementName = "<i>I don't see any of these statements on my ID Card</i>";
    }
};

const handleOtherNetwork = (net, other, noNetworkText) => {
    if (net.networkCode === "IDONTSEEONE") {
        net.networkStatementName += noNetworkText;
    }
    other.value.push(net);
};

const repositionOtherNetwork = (other) => {
    const otherIndex = other.value.findIndex(net => net.networkCode === "IDONTSEEONE");
    if (otherIndex !== -1) {
        other.value.push(other.value.splice(otherIndex, 1)[0]);
    }
};

export { formattedNetworks };